export const LanguageOptions = [
    {
        value: 'de',
        title: 'Deutsch'
    },
    {
        value: 'en',
        title: 'Englisch'
    },
    {
        value: 'fr',
        title: 'Französisch'
    },
    {
        value: 'es',
        title: 'Spanisch'
    },
    {
        value: 'it',
        title: 'Italienisch'
    },
    {
        value: 'pt',
        title: 'Portugiesisch'
    },
    {
        value: 'dk',
        title: 'Dänisch'
    },
    {
        value: 'fi',
        title: 'Finnisch'
    },
    {
        value: 'no',
        title: 'Norwegisch'
    },
    {
        value: 'se',
        title: 'Spanisch (Ecuador)'
    }
];
